import { render, staticRenderFns } from "./SectionTeam.vue?vue&type=template&id=3a4f35af&"
import script from "./SectionTeam.vue?vue&type=script&lang=js&"
export * from "./SectionTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports